export const isTutorialActive = (): boolean => {
  try {
    const tutorialData = localStorage.getItem('interactive-tutorial');
    if (!tutorialData) return false;
    const parsed = JSON.parse(tutorialData);
    return parsed.finished === false;
  } catch {
    return false;
  }
};
